import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { TranslationEditComponent } from '@app/translate/components/translation-edit/translation-edit.component';
import { TranslationOverviewComponent } from '@app/translate/components/translation-overview/translation-overview.component';
import { TranslateModule as NgxTranslateModule } from '@ngx-translate/core';

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';

registerLocaleData(localeEn);
registerLocaleData(localeDe);

@NgModule({
  imports: [SharedModule, ReactiveFormsModule],
  exports: [NgxTranslateModule],
  declarations: [TranslationEditComponent, TranslationOverviewComponent],
})
export class TranslateModule {}
